<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddForm('add')"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <!--        <el-button type="text" size="small" @click="toView(scope.row)">
          <span class="el-icon-view"></span>查看
        </el-button>-->
        <el-button type="text" size="small" icon="el-icon-edit" @click="toEdit(scope.row, 'edit')"
          >编辑</el-button
        >
        <el-button type="text" size="small" icon="el-icon-edit" @click="copyDevice(scope.row)"
          >复制
        </el-button>
        <el-button type="text" size="small" icon="el-icon-delete" @click="toDelete(scope.row)"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <avue-form
      v-if="showForm"
      ref="parkDeviceForm"
      v-model="form"
      :rules="rules"
      :option="option"
      @reset-change="emptyChange"
      @submit="submit"
    >
      <template slot-scope="scope" slot="menuForm">
        <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
      </template>
    </avue-form>
  </basic-container>
</template>

<script>
import { add, getList, remove, update } from '@/api/v4ward/park/device/parkdevice';
import { passageSelections } from '@/api/v4ward/park/passage/parkpassage';
import { syncData } from '@/api/v4ward/carv2/carparkspace';
import { getDictionaryWithIntKey } from '@/api/common';
import { mapGetters } from 'vuex';
export default {
  props: {
    parkSpace: {},
  },
  data() {
    return {
      loading: false,
      showForm: false,
      operateType: '',
      syncButtonLoading: false,
      form: {},
      deviceBrandList: [],
      commonDeviceList: [
        { lable: '否', value: 0 },
        { lable: '是', value: 0 },
      ],
      option: {
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        selection: false,
        columnBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        refreshBtn: false,
        emptyBtn: false,
        align: 'center',
        menuWidth: 180,
        column: [
          {
            label: '设备类型',
            prop: 'deviceType',
            type: 'select',
            width: 80,
            overHidden: true,
            maxlength: 20,
            dicUrl: '/api/blade-system/dict/dictionary?code=park_device_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择设备类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入设备名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备型号',
            prop: 'deviceBrandTypeName',
            editDisplay: false,
            addDisplay: false,
            display: false,
            width: 80,
            overHidden: true,
          },
          {
            label: '设备型号',
            prop: 'deviceBrandType',
            width: 100,
            overHidden: true,
            type: 'select',
            maxlength: 15,
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择设备型号',
                trigger: 'change',
              },
            ],
            hide: true,
            viewDisplay: false,
          },
          {
            label: '品牌名称',
            prop: 'deviceBrandName',
            overHidden: true,
            width: 80,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请选择品牌名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'LED型号',
            prop: 'ledType',
            overHidden: true,
            type: 'select',
            width: 80,
            maxlength: 20,
            dicUrl: '/api/blade-system/dict/dictionary?code=led_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择LED型号',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'LED配色方案',
            prop: 'ledMatchColor',
            overHidden: true,
            type: 'select',
            width: 100,
            maxlength: 20,
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=led_match_color',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择LED配色方案',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备编号',
            prop: 'deviceCode',
            overHidden: true,
            width: 80,
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入设备编号',
                trigger: 'change',
              },
              { pattern: /^[^\u4e00-\u9fa5]+$/, message: '格式错误' },
            ],
          },
          {
            label: '设备功能',
            prop: 'deviceFunctionType',
            type: 'select',
            width: 80,
            overHidden: true,
            editDisabled: true,
            maxlength: 20,
            dicUrl: '/api/blade-system/dict/dictionary?code=device_function_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择设备功能',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属通道',
            prop: 'passageName',
            display: false,
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '所属通道',
            prop: 'passageId',
            type: 'select',
            hide: true,
            viewDisplay: false,
            dicData: [],
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择设备所属通道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '公共摄像头',
            prop: 'commonDevice',
            type: 'select',
            hide: true,
            viewDisplay: false,
            dicData: [
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择是否为公共摄像头',
                trigger: 'change',
              },
            ],
          },
          {
            label: '排序号',
            prop: 'sort',
            type: 'number',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入排序号',
                trigger: 'change',
              },
              { pattern: /^[1-9][+]?\d{0,8}$/, message: '请输入9位以内数字' },
            ],
          },
          {
            label: '通讯方式',
            prop: 'communicationType',
            display: false,
            maxlength: 15,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入ip',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通讯地址',
            prop: 'communicationAddress',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入设备ip',
                trigger: 'change',
              },
              {
                pattern:
                  /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/,
                message: 'ip格式错误',
              },
            ],
          },
          {
            label: '状态',
            prop: 'deviceStatus',
            type: 'select',
            width: 80,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            maxlength: 20,
            dicUrl: '/api/blade-system/dict/dictionary?code=online_flag',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
          },
          {
            label: '设备序列号',
            prop: 'serialNumber',
            display: false,
            hide: true,
            maxlength: 32,
          },
          {
            label: '端口',
            prop: 'port',
            value: 80,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入正确端口号',
                trigger: 'change',
              },
              {
                pattern:
                  /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
                message: '格式错误',
              },
            ],
          },
          {
            label: '连接凭证',
            prop: 'authentication',
            maxlength: 32,
            hide: true,
          },
          {
            label: '华为云设备ID',
            prop: 'iotDeviceId',
            labelWidth: 120,
            rules: [
              {
                required: true,
                message: '请输入华为云设备ID',
                trigger: 'change',
              },
              { pattern: /^[^\u4e00-\u9fa5]+$/, message: '格式错误' },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            span: 24,
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkpassage_add, true),
      };
    },
    ids() {
      /* let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');*/
    },
  },
  watch: {
    'form.deviceType'() {
      this.loadDeviceBrand(this.form.deviceType);
    },
  },
  created() {
    setTimeout(() => {
      document.querySelector('#pane-parkDevice > div > div > div').style =
        'padding-top:0px !important';
      document.querySelector(
        '#pane-parkDevice > div > div > div > div.avue-crud > div.avue-crud__pagination'
      ).style = 'padding-top:0px !important';
    });
    this.loadPassageSelections();
  },
  mounted() {},
  methods: {
    loadPassageSelections() {
      passageSelections({ parkId: this.parkSpace.id }).then((res) => {
        if (this.operateType === 'add') {
          this.form.passageId = null;
        }
        const column = this.findObject(this.option.column, 'passageId');
        column.dicData = res.data;
      });
    },
    loadDeviceBrand(deviceType) {
      if (this.deviceBrandList.length === 0) {
        getDictionaryWithIntKey('park_device_brand').then((res) => {
          this.deviceBrandList = res.data;
          this.updateDeviceBrandList(deviceType);
        });
      } else {
        this.updateDeviceBrandList(deviceType);
      }
    },
    updateDeviceBrandList(deviceType) {
      const column = this.findObject(this.option.column, 'deviceBrandType');
      if (typeof deviceType === 'undefined') {
        column.dicData = this.deviceBrandList;
      } else {
        column.dicData = this.deviceBrandList.filter(function (s) {
          return Math.floor(s.dictKey / 10) === deviceType;
        });
      }
    },
    openAddForm(operateType) {
      this.operateType = operateType;
      this.cleanForm();
      this.showForm = !this.showForm;
      const column = this.findObject(this.option.column, 'deviceFunctionType');
      column.disabled = false;
    },
    copyDevice(row) {
      this.operateType = 'add';
      this.showForm = !this.showForm;
      this.form = Object.assign({}, row);
      this.form.id = '';
      this.form.deviceCode = '';
      this.form.passageId = '';
    },
    toEdit(row, operateType) {
      this.operateType = operateType;
      this.showForm = !this.showForm;
      this.form = Object.assign({}, row);
      if (operateType === 'edit') {
        const column = this.findObject(this.option.column, 'deviceFunctionType');
        column.disabled = true;
      }
    },
    toDelete(row) {
      this.$confirm('确定删除该设备?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        remove({ id: row.id })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.onLoad();
          })
          .catch(() => {
            this.onLoad();
          });
      });
    },
    onLoad() {
      this.loading = true;
      getList(Object.assign({ current: null, size: 20 }, { parkingLotId: this.parkSpace.id })).then(
        ({ data }) => {
          this.data = data.records;
          this.loading = false;
        }
      );
    },
    emptyChange() {
      if (this.operateType === 'add') {
        this.cleanForm();
      } else {
        this.$message.warning('编辑时清空无效！');
      }
    },
    submit(form, done) {
      if (this.vdui.isEmpty(form.id)) {
        this.form.parkingLotId = this.parkSpace.id;
        add(this.form).then(
          () => {
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            done();
            this.showForm = false;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      } else {
        update(this.form).then(
          () => {
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            done();
            this.showForm = false;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      }
    },
    syncParkInfo(type) {
      this.syncButtonLoading = true;
      const syncParam = {
        dataRange: 2,
        dataType: type,
        parkId: this.parkSpace.id,
      };
      syncData(syncParam).then(
        () => {
          this.$message.success('操作成功！');
          this.syncButtonLoading = false;
        },
        (error) => {
          window.console.log(error);
          this.syncButtonLoading = false;
        }
      );
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = '';
      }
      this.form.port = 80;
      this.form.authentication = 'admin/admin';
    },
  },
};
</script>
<style scoped></style>
